class DeleteStaffMember {
	constructor(
		public readonly organizationId: number,
		public readonly staffMemberId: number,
	) {
		Object.freeze(this);
	}
}

export default DeleteStaffMember;
